<div *ngIf="students && !students.length"><i>No students in class.</i></div>

<table class="table" *ngIf="students && students.length">
    <thead>
      <th>
        <app-sort-toggle columnName="Name" (orderChange)="updateSort($event)">
          Student
        </app-sort-toggle>
      </th>
      <th class="student-table">
        <app-sort-toggle columnName="LevelUnit" (orderChange)="updateSort($event)">
          Current <br> Level-Unit
        </app-sort-toggle>
      </th>
      <th class="student-table">
        <app-sort-toggle columnName="LastLogin" (orderChange)="updateSort($event)">
          Last Login
        </app-sort-toggle>
      </th>
      <th class="student-table">
        <app-sort-toggle columnName="TimeInAllCourses" (orderChange)="updateSort($event)">
          Total Time Spent
        </app-sort-toggle>
      </th>
      <th class="student-table">
        <app-sort-toggle columnName="UnitTest" (orderChange)="updateSort($event)">
          Unit Test Average
        </app-sort-toggle>
      </th>
      <th class="student-table">
        <app-sort-toggle columnName="SpeakingOpportunities" (orderChange)="updateSort($event)">
          Speaking Opportunities
        </app-sort-toggle>
      </th>
      <th *ngIf="showScores" class="student-table-speaking-score">
        <app-sort-toggle columnName="SpeakingScore" (orderChange)="updateSort($event)">
          SPARC<br/>Score
        </app-sort-toggle>
      </th>
    </thead>
    <tbody>
      <tr *ngFor="let obj of students"
        (click)="clickable ? goToRoute(obj, '/classes/' + organizationId + '/class/' + classId + '/students/' + obj.StudentID) : ''"
        [class.hover]="clickable">
        <td>
          <div class="d-flex">
            <a *ngIf="clickable" routerLink="/classes/{{ organizationId }}/class/{{ classId }}/students/{{ obj.StudentID }}">
              <app-profile-picture class="mr-2" [name]="obj.StudentName"></app-profile-picture>
              {{ obj.StudentName }}
            </a>
            <div *ngIf="!clickable">
              <app-profile-picture class="mr-2" [name]="obj.StudentName"></app-profile-picture>
              {{ obj.StudentName }}
            </div>
          </div>
        </td>
        <td class="student-table">
          {{ getCourseCodeAsLevel(obj.CurrentCourse) }} <span *ngIf="obj.CurrentCourse != 'Pathways'"> - <span class="nowrap">{{ getUnitText(obj.FurthestUnit) }}</span></span>
        </td>
        <td class="student-table">
          {{ obj.LastLogin | date }}
        </td>
        <td class="student-table">
          {{ displayTime(obj.TimeInAllCourses) }}
        </td>
        <td class="student-table">
          {{ obj.UnitTestTotal ? getUnitTestPercent(obj) : " &mdash; " }}%
        </td>
        <td class="student-table">
          {{ obj.SpeakingOpportunities | number }}
        </td>
        <td *ngIf="showScores" style="height: 100%;">
          <div style="display: flex; align-items: center; justify-content: right;">
            <span style="text-align:right;">{{ getSpeakingScore(obj)?.Score }}</span>
            <img *ngIf="getSpeakingScore(obj)" class="icon ml-1" src="assets/{{getScoreImage(obj)}}">
          </div>
        </td>
      </tr>
    </tbody>
</table>